.root {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
